import React from 'react'
import { Redirect, useLocation, useParams } from 'react-router'
import NotFoundView from 'views/NotFoundView'
import { useVersioning } from 'modules/versioning'
import { useGetArtboardByPermanentArtboardShortIdQuery } from '@sketch/gql-types'
import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'
import { LocationDescriptorObject } from 'history'
import { RouteParams } from '@sketch/constants'

/**
 * Redirects from the legacy PROTOTYPE route to the PROTOTYPE_VIEW route.
 */
export function PrototypeArtboardShortIdToUUIDRedirect() {
  const { permanentArtboardShortId } = useParams<RouteParams<'PROTOTYPE'>>()
  const { getPathname, versionShortId, share } = useVersioning()
  const { search } = useLocation()

  const { data, loading } = useGetArtboardByPermanentArtboardShortIdQuery({
    variables: {
      documentVersionShortId: versionShortId,
      permanentArtboardShortId,
      shareIdentifier: share.identifier,
    },
  })

  const uuid = data?.artboard?.uuid

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (!uuid) {
    return <NotFoundView />
  }

  const to: LocationDescriptorObject = {
    pathname: getPathname({
      routeKey: 'PROTOTYPE_VIEW',
      routeParams: {
        shareID: share.identifier,
        artboardUUID: uuid,
      },
    }),
    search,
  }

  return <Redirect to={to} push={false} />
}
